export default "__VITE_ASSET__cc196265__"